import type {RecordRow} from 'src/features/record-grid/lib/types';
import type {Readable} from 'svelte/store';
import type {Rec, UUID} from 'typings/portaro.be.types';
import type {ProjectLogbookPairingService} from './project-logbook-pairing.service';
import {writable} from 'svelte/store';
import {createContext, getContextOrThrow} from 'src/core';

const projectLogbookPairingContextKey = Symbol('project-logbook-pairing-ctx');

interface ProjectLogbookPairingContext {
    service: ProjectLogbookPairingService;
    projectRecord: Rec;
    openedLogbook$: Readable<RecordRow | null>;
    processedReports$: Readable<UUID[]>;
    setOpenedLogbook: (logbook: RecordRow | null) => void;
    addProcessedReport: (reportId: UUID) => void;
    removeProcessedReport: (reportId: UUID) => void;
}

export function createProjectLogbookPairingContext(projectRecord: Rec, service: ProjectLogbookPairingService): ProjectLogbookPairingContext {
    const openedLogbook = writable<RecordRow | null>(null);
    const processedReports = writable<UUID[]>([]);

    return createContext(projectLogbookPairingContextKey, {
        projectRecord,
        service,
        processedReports$: processedReports,
        openedLogbook$: openedLogbook,
        setOpenedLogbook: (logbook) => openedLogbook.set(logbook),
        addProcessedReport: (reportId) => processedReports.update((reports) => [...reports, reportId]),
        removeProcessedReport: (reportId) => processedReports.update((reports) => reports.filter((id) => id !== reportId))
    });
}

export function getProjectLogbookPairingContext(): ProjectLogbookPairingContext {
    return getContextOrThrow(projectLogbookPairingContextKey);
}